export default {
  notification: {
    success: {
      token: 'Código de acceso nuevo generado con éxito.',
      enableSharing: 'La función de compartición del dashboard se ha habilitado con éxito.',
    },
  },
  label: {
    title: {
      published: 'Compartición',
      publishedBy: 'Publicado por:',
      publishedAt: 'Publicado en:',
      token: 'Código de acceso',
      hiddenComponents: 'Componentes ocultos',
      description: {
        token: 'Al generar un código nuevo, los usuarios que acceden a este dashboard con el código actual perderán el acceso.',
        dashboardHidden: 'Este dashboard contiene componentes con información sensible que no debe ser accesible para usuarios invitados. Si procede con la compartición, esos componentes se ocultarán automáticamente. Para más información, visite nuestro',
        dashboardHiddenCentralLink: 'Centro de Ayuda',
        dashboardHiddenAux: ' y consulte nuestra',
        dashboardHiddenPolicyLink: ' Política de Compartición.',
      },
    },
    panel: {
      components: 'Componentes',
    },
    tooltip: {
      notPermitted: 'Debe iniciar sesión para cambiar las opciones de compartición.',
      notPublished: 'Dashboard no publicado. Al publicar, estará visible para cualquiera.',
      published: 'Dashboard publicado.',
      publishedBy: 'Publicado por:',
    },
    pagination: 'Mostrando {page} - {size} de {count}',
    switch: 'Dashboard compartido',
    url: 'URL de acceso',
    token: 'Código de acceso',
    button: {
      regenerateToken: 'Generar nuevo código de acceso',
      remove: 'Eliminar componentes',
    },
  },
};
